"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnvironmentProvider = void 0;
var _react = require("react");
var _constants = require("../../constants");
var _environmentContext = require("./environmentContext");
var _jsxRuntime = require("react/jsx-runtime");
const EnvironmentProvider = ({
  children,
  tenant,
  environment = _constants.ENVIRONMENT_CODES.LIVE
}) => {
  const contextValues = (0, _react.useMemo)(() => ({
    tenant,
    environment
  }), [tenant, environment]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_environmentContext.environmentContext.Provider, {
    value: contextValues,
    children: children
  });
};
exports.EnvironmentProvider = EnvironmentProvider;
//# sourceMappingURL=EnvironmentProvider.js.map